export default function accordion() {
    const accordionElements = document.querySelectorAll('.accordion .accordion-element');
    
    accordionElements.forEach( (element, i) => {
        //initial vars
        const content = element.querySelector('.accordion-content');

        // Check if the accordion element starts expanded -- For an element to
        // start expanded you need either to add the .expanded class or to get
        // to the page using an anchor
        if( 
            element.classList.contains('expanded') ||
            window.location.hash === `#${element.id}`
        ) {
            element.setAttribute('aria-expanded', 'true');
            content.classList.add('expanded');
        }

        // Open/Collapse function
        element.querySelector('.accordion-title').addEventListener('click', (e) => {
            e.preventDefault();
            
            const expanded = element.getAttribute('aria-expanded') === 'true';

            if (expanded) {
                element.setAttribute('aria-expanded', 'false');
                content.classList.remove('expanded');
            } else {
                // Close all other accordion items
                accordionElements.forEach(otherElements => {
                    otherElements.setAttribute('aria-expanded', 'false');
                    otherElements.querySelector('.accordion-content').classList.remove('expanded');
                });
                
                // Open this accordion item
                element.setAttribute('aria-expanded', 'true');
                content.classList.add('expanded');
            }
        });

        // Set height for smoother transition
        element.querySelector('.accordion-content').style = `--height: ${element.querySelector('.accordion-content').scrollHeight + 5}px;`
    });
}